import { createThemeControl } from "../komponenter/theme-control";

const liveHosts = new Set([
    `energikilden.com`, `www.energikilden.com`, `registrerevarme.no`, `www.registrerevarme.no`
]);

export const initThemeControl = () => {
    if (liveHosts.has(window.location.hostname.toLowerCase())) return;
    if (document.getElementById(`theme-choice`)) return;

    const control = createThemeControl(`theme-choice`);
    const userStatus = document.querySelector<HTMLElement>(`.user-status`);
    if (userStatus) userStatus.append(control);
    else document.body.prepend(control);
};
